export default __webpack_public_path__ + "static/media/hollowCircle.7c8a507c.svg";